import styled from '@emotion/styled'

export const RepeatsMessage = styled.p`
  color: #3c4043;
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  opacity: 1;
  padding: 12px 16px;
  text-align: center;
  text-decoration: none;
  text-transform: none;
`
